import React from "react";
import { PanelEditSlider } from "../../../UI/Sliders/Edit/PanelEditSlider";

const EditSlider = () => {
  return (
    <div>
      <PanelEditSlider />
    </div>
  );
};

export default EditSlider;
